@if (!isDrawer()) {
  <div class="sheet-backdrop" (click)="requestClose()"></div>
}
<div class="sheet" role="dialog" aria-label="Switch team">
  @if (backLabel(); as dest) {
    <div class="grab" (pointerdown)="drawerDrag.start($event)">
      <div class="handle" aria-hidden="true"></div>
    </div>
    <div class="sheet-back">
      <app-play-back-row [dest]="dest" (back)="requestClose()" />
    </div>
  } @else {
    <div class="sheet-title ui-label">
      <span>
        {{ mode() === 'home' ? 'SWITCH TEAM' : 'YOUR TEAMS' }}
        @if (mode() === 'teams') {
          <span class="count">· {{ teamList.teams().length }} / {{ MAX_TEAMS }}</span>
        }
      </span>
      <button class="close-x" (click)="requestClose()" aria-label="Close">×</button>
    </div>
  }

  <div class="sheet-body">
    @for (team of teamList.teams(); track trackBySlot($index, team)) {
      <button class="sheet-team-row"
              [class.row-card]="isDrawer()"
              [class.active]="team.isActive"
              (click)="selectRow(team.slot)">
        @if (team.isDefault) {
          <span class="default-mark">★</span>
        }
        <span class="row-name">{{ team.name }}</span>
        <span class="row-mons">
          @for (id of team.monIds; track $index) {
            <app-mon-static-sprite class="row-mini" [monId]="monIdAsNumber(id)" spriteType="mini" />
          }
        </span>
      </button>
    }
  </div>

  <div class="sheet-footer">
    <button class="modal-btn modal-btn--block new-team-btn"
            [disabled]="teamList.teams().length >= MAX_TEAMS || teamList.draftSlot() !== null"
            (click)="newTeam()">
      <span class="plus">+</span>
      <span class="label">NEW TEAM</span>
      @if (mode() === 'home') {
        <span class="route-hint">→ /teams</span>
      }
    </button>
  </div>
</div>
